// extracted by mini-css-extract-plugin
module.exports = {"text":"ErrorMessageComponent_text__3NOtM","error":"ErrorMessageComponent_error__3Okqn"};